import { render, staticRenderFns } from "./ChatOptions.vue?vue&type=template&id=323cba20&scoped=true&"
import script from "./ChatOptions.vue?vue&type=script&lang=js&"
export * from "./ChatOptions.vue?vue&type=script&lang=js&"
import style0 from "./ChatOptions.vue?vue&type=style&index=0&id=323cba20&prod&lang=scss&"
import style1 from "./ChatOptions.vue?vue&type=style&index=1&id=323cba20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323cba20",
  null
  
)

export default component.exports